export interface Link {
    href: string;
}

export interface Question {
    id: string;
    vacancyId: string;
    text: string;
}

export interface AnswerLinks {
    self: Link;
}

export interface Answer {
    id: string;
    questionId: string;
    videoLink: string | undefined;
    _links?: AnswerLinks;
}

export enum ApplicationState {
    CREATED = 'CREATED',
    INVITATION_SENT = 'INVITATION_SENT',
    APPLICATION_SUBMITTED = 'APPLICATION_SUBMITTED',
    APPLICATION_ACCEPTED = 'APPLICATION_ACCEPTED',
    APPLICATION_REJECTED = 'APPLICATION_REJECTED'
}



// WEBPACK FOOTER //
// ./src/types/api.ts